import type React from 'react';
import { cn } from '../../lib/utils.ts';

type Props = {
    className?: string;
};

export const CopyIcon: React.FC<Props> = ({ className = '' }) => {
    return (
        <svg
            className={cn('stroke-neutral-400', className)}
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            fill="none"
            viewBox="0 0 14 14"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.3"
                d="M9.625 4.813V3.5c0-.725-.588-1.313-1.313-1.313H3.5c-.725 0-1.313.588-1.313 1.313v4.813c0 .724.588 1.312 1.313 1.312h1.313m4.812-4.813h.875c.725 0 1.313.588 1.313 1.313V10.5c0 .725-.588 1.313-1.313 1.313H6.125A1.312 1.312 0 014.812 10.5v-.875m4.813-4.813h-3.5c-.725 0-1.313.588-1.313 1.313v3.5"
            ></path>
        </svg>
    );
};
